import { DispatchNumber_Read_Nested } from '@treadinc/horizon-api-spec';

export class DispatchNumberBasic {
  constructor(
    private _id: string,
    private _name: string,
  ) {}

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public static parse(proto: DispatchNumber_Read_Nested) {
    return new DispatchNumberBasic(proto.id, proto.name);
  }
}
